/* ==========================================================================
   AutocompleteRxjs > Client > Store > Reducer
   ========================================================================== */

/* Modules */
const { types } = require('./actions');

/* Initial state */
const initialState = {
    active: false,
    disabled: false,
    hidden: false,
    error: false,
    valid: false,
    suggestions: [],
    openSuggestions: false,
    tooltipType: '',
    query: '',
    value: null,
    isLoading: false
};

/* Reducer */
function reducer(state = initialState, action) {
    const { type, payload = {} } = action;
    return (
        {
            [types.DISABLE]: {
                ...state,
                disabled: true
            },
            [types.ENABLE]: {
                ...state,
                disabled: false
            },
            [types.DISPLAY]: {
                ...state,
                hidden: false
            },
            [types.HIDE]: {
                ...state,
                hidden: true
            },
            [types.TOGGLE_ACTIVE]: {
                ...state,
                active: !state.active
            },
            [types.SET_VALUE]: {
                ...state,
                value: payload
            },
            [types.CHANGE_VALUE]: {
                ...state,
                value: payload
            },
            [types.RESET_STATUS]: {
                ...state,
                error: false,
                valid: false
            },
            [types.SET_ERROR]: {
                ...state,
                error: true,
                valid: false
            },
            [types.SET_UI_STATE]: {
                ...state,
                active: payload.active || state.active,
                hidden: payload.hidden || state.hidden,
                isLoading: payload.isLoading || state.isLoading
            },
            [types.SET_VALID]: {
                ...state,
                error: false,
                valid: true
            },
            [types.CLEAR]: {
                ...state,
                suggestions: [],
                query: '',
                value: null,
                openSuggestions: false
            },
            [types.CLOSE_SUGGESTIONS]: {
                ...state,
                openSuggestions: false
            },
            [types.OPEN_SUGGESTIONS]: {
                ...state,
                tooltipType: payload,
                openSuggestions: true
            },
            [types.SET_QUERY]: {
                ...state,
                query: payload
            },
            [types.SET_SUGGESTIONS]: {
                ...state,
                suggestions: payload
            },
            [types.TOGGLE_LOADING]: {
                ...state,
                isLoading: !state.isLoading
            }
        }[type] || state
    );
}

/* Exports */
module.exports = {
    reducer
};
